import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import { Trash2, Pencil } from "lucide-react";
import { http, apiError } from "@/lib/api";

const input = "mt-1 h-11 w-full rounded-lg border border-black/20 bg-white px-3 text-sm";
const empty = { email: "", name: "", role: "editor", password: "", active: true };

export default function AdminUsers() {
  const { isAdmin, user } = useOutletContext();
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState(empty);
  const load = () => http.get("/admin/users").then((r) => setUsers(r.data)).catch((e) => toast.error(apiError(e)));
  useEffect(() => { if (isAdmin) load(); }, [isAdmin]);
  if (!isAdmin) return <p>Acesso reservado a administradores.</p>;
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const save = async (e) => {
    e.preventDefault();
    try {
      if (form.id) await http.put(`/admin/users/${form.id}`, { ...form, password: form.password || null });
      else await http.post("/admin/users", form);
      toast.success("Utilizador guardado"); setForm(empty); load();
    } catch (err) { toast.error(apiError(err)); }
  };
  const remove = async (u) => {
    if (!window.confirm(`Eliminar ${u.email}?`)) return;
    try { await http.delete(`/admin/users/${u.id}`); load(); } catch (err) { toast.error(apiError(err)); }
  };
  return (
    <div className="grid gap-8 lg:grid-cols-[1fr_380px]" data-testid="admin-users">
      <div>
        <h1 className="font-display text-3xl font-extrabold">Utilizadores</h1>
        <ul className="mt-6 divide-y rounded-2xl border bg-white">
          {users.map((u) => (
            <li key={u.id} className="flex items-center gap-3 p-4" data-testid={`user-row-${u.email}`}>
              <div className="flex-1 min-w-0"><p className="font-semibold truncate">{u.name || u.email}</p><p className="text-xs text-slate-500">{u.email} · {u.role === "admin" ? "Administrador" : "Editor"}{!u.active && " · inativo"}</p></div>
              <button onClick={() => setForm({ ...u, password: "" })} className="h-10 w-10 grid place-items-center rounded-lg hover:bg-black/5" aria-label="Editar" data-testid={`user-edit-${u.email}`}><Pencil className="h-4 w-4" /></button>
              {u.id !== user.id && <button onClick={() => remove(u)} className="h-10 w-10 grid place-items-center rounded-lg text-red-700 hover:bg-red-50" aria-label="Eliminar" data-testid={`user-delete-${u.email}`}><Trash2 className="h-4 w-4" /></button>}
            </li>
          ))}
        </ul>
      </div>
      <form onSubmit={save} className="rounded-2xl border bg-white p-5 space-y-3 self-start" data-testid="user-form">
        <p className="font-display text-xl font-bold">{form.id ? "Editar utilizador" : "Novo utilizador"}</p>
        <label className="block text-sm font-semibold">Email<input type="email" required disabled={!!form.id} value={form.email} onChange={(e) => set("email", e.target.value)} className={input} data-testid="user-form-email" /></label>
        <label className="block text-sm font-semibold">Nome<input value={form.name} onChange={(e) => set("name", e.target.value)} className={input} data-testid="user-form-name" /></label>
        <label className="block text-sm font-semibold">Função<select value={form.role} onChange={(e) => set("role", e.target.value)} className={input} data-testid="user-form-role"><option value="editor">Editor</option><option value="admin">Administrador</option></select></label>
        <label className="block text-sm font-semibold">Palavra-passe {form.id && "(deixe vazio para manter)"}<input type="password" minLength={8} required={!form.id} value={form.password} onChange={(e) => set("password", e.target.value)} className={input} data-testid="user-form-password" /></label>
        <label className="flex items-center gap-2 text-sm font-semibold"><input type="checkbox" checked={form.active} onChange={(e) => set("active", e.target.checked)} className="h-5 w-5" data-testid="user-form-active" />Conta ativa</label>
        <div className="flex gap-2"><button className="h-11 px-5 rounded-full bg-[var(--leaf)] text-white font-bold" data-testid="user-form-save">Guardar</button>{form.id && <button type="button" onClick={() => setForm(empty)} className="h-11 px-5 rounded-full border font-semibold">Cancelar</button>}</div>
      </form>
    </div>
  );
}
